/**
 * defaults.js — All initial state values.
 */
export const DEF = {
  onboarded: false,
  streak: { current: 0, best: 0, lastDate: null, budgetStreak: 0, history: [] },
  questsCompleted: {},
  age: 22, nw0: 17225, startAge: 24, salary: 100000, bonusR: 0.12, salGr: 0.06, liv: 40000,
  inflation: 0.025, maxAge: 40, tfsaRoom: 95000, penAge: 60, rrspPct: 60,
  s22: 30000, s25: 50000, s30: 70000, s35: 100000, tLim: 7000, ret: 0.10, xeqt: 100,
  hPrice: 1050000, hAge: 25, down: 250000, mortAmt: 800000, mortRate: 0.045, amortYrs: 25,
  xPrin: 25000, hApp: 0.04,
  cPMP: false, cAWS: false, cCISSP: false, spousal: true, dark: true,
  budgetSync: true,
  ms: { 25: false, 30: false, 35: false, 40: false }, manNW: {},
  customMs: [
    { a: 25, nw: 550000, l: "House closed · $550k NW" },
    { a: 30, nw: 1400000, l: "Pension vested · $1.4M NW" },
    { a: 35, nw: 3100000, l: "$3.1M NW · $195k salary" },
    { a: 40, nw: 5200000, l: "$5.2M+ total NW" },
  ],
  cheq: 3200, ccBal: 850, ccLim: 8000, cScore: 720,
  efTarget: 6,
  cats: [
    { id: "h", n: "Housing", b: 1600, a: 1600, c: "#0A84FF" },
    { id: "f", n: "Food & Groceries", b: 400, a: 380, c: "#30D158" },
    { id: "t", n: "Transport", b: 200, a: 165, c: "#FF9F0A" },
    { id: "s", n: "Subscriptions", b: 80, a: 78, c: "#BF5AF2" },
    { id: "p", n: "Personal", b: 200, a: 140, c: "#FF375F" },
    { id: "o", n: "Other", b: 200, a: 95, c: "#64D2FF" },
  ],
  csHist: [
    { m: "Sep", s: 695 }, { m: "Oct", s: 702 }, { m: "Nov", s: 710 },
    { m: "Dec", s: 715 }, { m: "Jan", s: 718 }, { m: "Feb", s: 720 },
  ],
  scenarios: [],
};
